var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('NuxtLink',{attrs:{"to":_vm.localePath('impressum')}},[_vm._v(_vm._s(_vm.$t('footer.legal')))]),_vm._v(" | "),_c('NuxtLink',{attrs:{"to":_vm.localePath('datenschutz')}},[_vm._v(_vm._s(_vm.$t('footer.data')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }